module.exports = __webpack_public_path__ + "static/media/slate_coiffeur.1364f8be.png";